import styled, { linkStyles, MQ_TABLET } from '../../../src/constants/theme'

export default styled.div<{ fontSize?: number }>(
  {
    maxWidth: '100%',
    textAlign: 'center',
    width: 500,
  },
  ({ fontSize, theme }) => ({
    ...MQ_TABLET({
      '& + &': {
        paddingTop: 0,
      },
      padding: theme.padding,
    }),
    '& + &': {
      paddingTop: 0,
    },
    '& a': {
      ...linkStyles,
    },
    padding: theme.paddingMobile,
    ...(fontSize ? { fontSize, paddingTop: 0 } : undefined),
  }),
)
